import { render, staticRenderFns } from "./FormWithoutModal.vue?vue&type=template&id=04aff40a"
import script from "./FormWithoutModal.vue?vue&type=script&lang=js"
export * from "./FormWithoutModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports